import { render, staticRenderFns } from "./TeacherDataTable.vue?vue&type=template&id=231b9912"
import script from "./TeacherDataTable.vue?vue&type=script&lang=js"
export * from "./TeacherDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports